import {Api} from '../api';
import {EventBus} from './';

export default {
    setup() {
        try {
            document.domain = process.env.DOMAIN || 'localhost';
        } catch (e) {
            console.error(e);
        }

        window.authTokenReceived = (token) => {
            Api.user.setToken(token);
            EventBus.$emit(EventBus.LOGIN_DONE, {success: true, token: token});
        };

        window.remoteLoginCanceled = () => {
            EventBus.$emit(EventBus.REMOTE_LOGIN_CANCELED);
        };
    }
};



// WEBPACK FOOTER //
// ./src/utils/BVCDLogin.js